var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30434 6.26081C7.30434 4.51247 8.53308 3.05194 10.1739 2.69358C9.9217 2.63855 9.66009 2.60869 9.39127 2.60869C7.37419 2.60869 5.73909 4.24378 5.73909 6.26086C5.73909 8.27794 7.37419 9.91303 9.39127 9.91303C9.66 9.91303 9.92166 9.88317 10.1739 9.82809C8.53308 9.46974 7.30434 8.0092 7.30434 6.26081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.86955L12.259 3.66666H13.0972L12.4191 4.15936L12.6781 4.95647L12 4.46386L11.3219 4.95647L11.5809 4.15936L10.9028 3.66666H11.741L12 2.86955Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9668 4.43475L10.2258 5.23191H11.064L10.3859 5.72456L10.6449 6.52167L9.9668 6.02906L9.28861 6.52167L9.54769 5.72456L8.86954 5.23191H9.70772L9.9668 4.43475Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0333 4.43475L14.2923 5.23191H15.1305L14.4523 5.72456L14.7114 6.52167L14.0333 6.02906L13.3552 6.52167L13.6142 5.72456L12.9361 5.23191H13.7742L14.0333 4.43475Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2507 6.78258L13.5097 7.57974H14.3478L13.6697 8.07239L13.9288 8.8695L13.2507 8.37689L12.5726 8.8695L12.8316 8.07239L12.1535 7.57974H12.9916L13.2507 6.78258Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7494 6.78258L11.0084 7.57974H11.8466L11.1684 8.07239L11.4275 8.8695L10.7494 8.37689L10.0712 8.8695L10.3303 8.07239L9.65217 7.57974H10.4903L10.7494 6.78258Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.49d6b70a5117865447bc850865d4f3bd.svg";
export { ForwardRef as ReactComponent };